import { render, staticRenderFns } from "./ConsumptionCategoryTips.vue?vue&type=template&id=0ee07a58&scoped=true&"
import script from "./ConsumptionCategoryTips.vue?vue&type=script&lang=js&"
export * from "./ConsumptionCategoryTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee07a58",
  null
  
)

export default component.exports